export default __webpack_public_path__ + "6fb4fe0dfb78e24111af44cbd5eaebe0.png";